import * as React from "react";
import Grid from "components/Grid";
import Modal from "components/Modal";
import InputCustom from "components/InputCustom";
import Joi from "joi";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { useValidator } from "react-joi";
import { useDispatch, useSelector } from "react-redux";
import {
  getCedisOrigin,
  addOrUpdateCedisOrigin,
  deleteCedisOrigin,
  getClientList,
} from "actions/Catalogs";
import AddressForm from "components/AddressForm";
import { notify } from "utils";
import { parseISO, format } from "date-fns/esm";
import { filterDate } from "components/DateCatalogs/filterDate";

const CedisOrigin = ({ view }) => {
  const [t] = useTranslation("catalog");
  const [tg] = useTranslation("global");
  const dispatch = useDispatch();
  const { clients, cedisOriginList } = useSelector((state) => state.catalog);
  const { currentProject } = useSelector((state) => state.auth);
  const [openModal, setOpenModal] = React.useState(false);
  const [id, setId] = React.useState();
  const [idAddress, setIdAddress] = React.useState();
  const [coords, setCoords] = React.useState({});
  const [defaultCoords, setDefaultCoords] = React.useState({});
  const [isLoad, setIsLoad] = React.useState(false);
  const { permissions } = view;

  const { state, setData, setExplicitField, validate, reset } = useValidator({
    initialData: {
      code: null,
      description: null,
      shPt: null,
      projectId: null,
      country: null,
      state: null,
      city: null,
      cologne: null,
      postalCode: null,
      street: null,
      exteriorNumber: null,
      interiorNumber: "",
      codeAddress: null,
      descriptionAddress: null,
    },
    schema: Joi.object({
      code: Joi.string()
        .min(2)
        .max(100)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.alphanumeric"),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '100' }),
          'any.required': t("error.required")
        }),
      description: Joi.string()
        .min(2)
        .max(300)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.type", { type: 'string' }),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '300' }),
          'any.required': t("error.required")
        }),
      shPt: Joi.string()
        .min(2)
        .max(100)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.alphanumeric"),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '150' }),
          'any.required': t("error.required")
        }),
      projectId: Joi.number().required(),
      country: Joi.string()
        .min(2)
        .max(150)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.type", { type: 'string' }),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '150' }),
          'any.required': t("error.required")
        }),
      state: Joi.string()
        .min(2)
        .max(150)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.type", { type: 'string' }),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '150' }),
          'any.required': t("error.required")
        }),
      city: Joi.string()
        .min(2)
        .max(150)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.type", { type: 'string' }),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '150' }),
          'any.required': t("error.required")
        }),
      cologne: Joi.string()
        .min(2)
        .max(150)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.type", { type: 'string' }),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '150' }),
          'any.required': t("error.required")
        }),
      postalCode: Joi.string().length(5).message(t("error.max_length")).pattern(/^[0-9]+$/).message(t("error.number_format")).required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.type", { type: 'number' }),
          'any.required': t("error.required")
        }),
      street: Joi.string()
        .min(2)
        .max(150)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.type", { type: 'string' }),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '150' }),
          'any.required': t("error.required")
        }),
      exteriorNumber: Joi.string()
        .min(2)
        .max(10)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.alphanumeric"),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '10' }),
          'any.required': t("error.required")
        }),
      interiorNumber: Joi.string()
        .min(2)
        .max(10)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.alphanumeric"),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '10' }),
          'any.required': t("error.required")
        }),
      codeAddress: Joi.string()
        .min(2)
        .max(50)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.alphanumeric"),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '50' }),
          'any.required': t("error.required")
        }),
      descriptionAddress: Joi.string()
        .min(2)
        .max(150)
        .required()
        .messages({
          'string.empty': t("error.empty"),
          'string.base': t("error.type", { type: 'string' }),
          'string.min': t("error.min"),
          'string.max': t("error.max", { quantity: '150' }),
          'any.required': t("error.required")
        }),
    }),
    explicitCheck: {
      code: false,
      description: false,
      shPt: false,
      projectId: false,
      country: false,
      state: false,
      city: false,
      cologne: false,
      postalCode: false,
      street: false,
      exteriorNumber: false,
      interiorNumber: false,
      codeAddress: false,
      descriptionAddress: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  });

  const buttonRef = React.useRef();

  React.useEffect(() => {
    dispatch(getClientList());
  }, [dispatch]);

  React.useEffect(() => {
    if (currentProject && currentProject?.id) {
      dispatch(getCedisOrigin(currentProject?.id));
    }
  }, [dispatch, currentProject]);

  const clearForm = () => {
    setDefaultCoords(null);
    reset();
    setId(null);
  };

  const handleOnSubmit = async () => {
    if (state.$all_errors.length > 0 || state.$all_source_errors.length > 0) {
      validate();
      notify("error", t("error.general_toast"), 1200);
      return;
    }
    const {
      code,
      description,
      shPt,
      projectId,
      country,
      city,
      cologne,
      postalCode,
      street,
      exteriorNumber,
      interiorNumber,
      codeAddress,
      descriptionAddress,
    } = state.$data;

    setIsLoad(true);
    if (buttonRef & buttonRef?.current) buttonRef.current.disabled = true;
    let data = {
      code,
      description,
      shPt,
      IdProject: projectId,
      address: {
        country,
        state: state.$data.state,
        city,
        cologne,
        postalCode,
        street,
        exteriorNumber,
        interiorNumber,
        code: codeAddress,
        description: descriptionAddress,
        lat: coords ? coords.lat : 0,
        lon: coords ? coords.lng : 0,
        IdProject: projectId,
      },
    }
    if (id) {
      data.id = id;
      data.address.id = idAddress;
    }
    const isSuccess = await dispatch(
      addOrUpdateCedisOrigin(data)
    );
    if (buttonRef & buttonRef?.current) buttonRef.current.disabled = false;
    setIsLoad(false);

    if (isSuccess) {
      clearForm();
      setIdAddress(null);
      setOpenModal(false);
    }
  };

  const handleDelete = async (idCedis, idProject) => {
    Swal.fire({
      title: tg("button.title"),
      text: tg("button.text"),
      icon: "error",
      confirmButtonText: tg("button.confirm"),
      cancelButtonText: tg("button.cancel"),
      cancelButtonColor: "#000000",
      confirmButtonColor: "#FF3447",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await dispatch(deleteCedisOrigin(idCedis, idProject));
      }
    });
  };

  return (
    <>
      <Grid
        title={t("cedisOrigin.title")}
        columns={[
          {
            Header: "Id",
            accessor: "id",
            filter: "text",
            Cell: ({ value }) => {
              return value
            },
            width: 40
          },
          {
            Header: "Code",
            accessor: "code",
            filter: "text",
            width: 100
          },
          {
            Header: t("shPt"),
            accessor: "shPt",
            width: 120
          },
          {
            Header: t("cedisOrigin.description"),
            accessor: "description",
            disableFilters: false,
            width: 230
          },
          {
            Header: tg("addressForm.address"),
            accessor: "address.code",
            width: 230
          },
          {
            Header: tg("addressForm.references"),
            accessor: "address.description",

            width: 230
          },
          {
            Header: tg("addressForm.country"),
            accessor: "address.country",
            disableFilters: false,
            width: 80

          },
          {
            Header: tg("addressForm.state"),
            accessor: "address.state",
            disableFilters: false,
            width: 140
          },
          {
            Header: tg("addressForm.municipality"),
            accessor: "address.city",
            width: 140
          },
          {
            Header: tg("addressForm.colony"),
            accessor: "address.cologne",
            width: 280
          },
          {
            Header: tg("addressForm.street"),
            accessor: "address.street",
            width: 280

          },
          {
            Header: tg("addressForm.outside_number"),
            accessor: "address.exteriorNumber",
            width: 60
          },
          {
            Header: tg("addressForm.inside_number"),
            accessor: "address.interiorNumber",
            width: 60
          },
          {
            Header: tg("addressForm.postal_code"),
            accessor: "address.postalCode",
            width: 60,
            filter: false
          },
          {
            Header: t("cedisOrigin.updated_at"),
            accessor: "updatedAt",
            width: 110,
            filter: filterDate,
            Cell: ({ value }) => {
              if (value) return format(parseISO(value), "dd/MM/yyyy HH:mm");
              return value;
            },
          },
        ]}
        data={cedisOriginList || []}
        handleAdd={() => {
          if (permissions.write) {
            setOpenModal(true);
          }
        }}
        handleEdit={(row) => {
          const {
            id,
            code,
            description,
            shPt,
            idProject,
            address: {
              country,
              city,
              cologne,
              postalCode,
              street,
              exteriorNumber,
              interiorNumber,
              lat,
              lon,
            },
          } = row;

          setId(id);
          setIdAddress(row.address.id);
          setData((old) => ({
            ...old,
            code,
            description,
            shPt,
            projectId: idProject,
            country,
            state: row.address.state,
            city,
            cologne,
            postalCode: postalCode.toString(),
            street,
            exteriorNumber,
            interiorNumber,
            codeAddress: row.address.code,
            descriptionAddress: row.address.description,
          }));
          setDefaultCoords({ lat: lat, lng: lon });
          setOpenModal(true);
        }}
        handleDelete={({ id, idProject }) => {
          if (id) handleDelete(id, idProject);
        }}
        write={permissions.write}
      />

      {openModal ? (
        <Modal
          openModal={openModal}
          closeModal={() => {
            clearForm();
            setOpenModal(false);
            setId(null);
            setIdAddress(null);
          }}
          titleModal={t("cedisOrigin.title")}
          onSubmit={handleOnSubmit}
          disableAdd={state.$invalid}
          iconEdit={id > 0 ? true : false}
          buttonRef={buttonRef}
          processFetch={isLoad}
          size={"xlg"}
        >
          <h4 className="font-[Gravity] font-bold tex-[18px] my-2">
            {t("cedisOrigin.info_modal")}
          </h4>
          <div className="grid grid-cols-3 gap-2">
            <InputCustom
              type={"text"}
              labelText="Code:"
              errorMessage={
                state.$errors.code.length > 0 ? state.$errors.code[0].$message : null
              }
              onChange={(e) => {
                e.persist();
                setData((old) => ({
                  ...old,
                  code: e.target.value,
                }));
              }}
              value={state.$data.code ? state.$data.code : ""}
              onBlur={() => setExplicitField("code", true)}
              key="code"
              toolTip={t("cedisOrigin.tooltip.general")}
            />
            <InputCustom
              type={"text"}
              labelText={t("cedisOrigin.description")}
              errorMessage={
                state.$errors.description.length > 0 ? state.$errors.description[0].$message : null
              }
              onChange={(e) => {
                e.persist();
                setData((old) => ({
                  ...old,
                  description: e.target.value,
                }));
              }}
              value={state.$data.description ? state.$data.description : ""}
              onBlur={() => setExplicitField("description", true)}
              key="description"
            />
            <InputCustom
              type={"text"}
              labelText="ShPt:"
              errorMessage={
                state.$errors.shPt.length > 0 ? state.$errors.shPt[0].$message : null
              }
              onChange={(e) => {
                e.persist();
                setData((old) => ({
                  ...old,
                  shPt: e.target.value,
                }));
              }}
              value={state.$data.shPt ? state.$data.shPt : ""}
              onBlur={() => setExplicitField("shPt", true)}
              toolTip={t("cedisOrigin.tooltip.general")}
              key="shPt"
            />
            <InputCustom
              type={"select"}
              labelText={t("cedisOrigin.project")}
              errorMessage={
                state.$errors.projectId.length > 0 ? t("error.general") : null
              }
              onChange={(e) => {
                e.persist();
                setData((old) => ({
                  ...old,
                  projectId: e.target.value,
                }));
              }}
              options={
                clients &&
                clients.map((item) => ({
                  value: item.id,
                  text: item.name,
                }))
              }
              value={state.$data.projectId ? state.$data.projectId : ""}
              onBlur={() => setExplicitField("projectId", true)}
              key="projectId"
            />
          </div>
          <AddressForm
            state={state}
            setData={setData}
            setExplicitField={setExplicitField}
            fieldDescriptionName={"descriptionAddress"}
            setCoords={setCoords}
            defaultCoords={defaultCoords}
          />
        </Modal>
      ) : null}
    </>
  );
};
export default CedisOrigin;
